module.exports = __webpack_public_path__ + "static/media/2YearResidency.7dfbc203.svg";